import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import moment from "moment";
import * as utils from "../../Utils/comman";
import { json, Link } from "react-router-dom";
import { useSelector } from "react-redux";

function QCSpecification({ props, updatedFinishGood }) {
  const [productSpecifications, setProductSpecifications] = useState([]);
  const [testResults, setTestResults] = useState([]);
  const [remark, setRemark] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalReason, setModalReason] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [testErrors, setTestErrors] = useState({});
  const [statuss, setstatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  useEffect(() => {
    if (props.rowData?.product_id) {
      getProductSpecifications(props.rowData?.product_id);
    }
  }, [props.rowData]);

  const getProductSpecifications = (productId) => {
    utils
      .callAPI(
        "get",
        `production/specification/get-specification?product_id=${productId}`
      )
      .then((res) => {
        if (res) {
          setProductSpecifications(res);
          setTestResults(res.map((item) => ({ id: item.id, testResult: "" })));
        } else {
          setProductSpecifications([]);
          setTestResults([]);
        }
      })
      .catch(() => {
        setProductSpecifications([]);
        setTestResults([]);
      });
  };

  const handleTestResultChange = (id, value) => {
    setTestResults((prevResults) =>
      prevResults.map((result) =>
        result.id === id ? { ...result, testResult: value } : result
      )
    );
  };

  console.log(props?.rowData)

  const handleFinalSave = () => {
    const errors = {};

    // Only require test results if the status is "approve"
    if (statuss.toLowerCase() === "approve") {
      testResults.forEach((result) => {
        if (!result.testResult.trim()) {
          errors[result.id] = "Test result is required.";
        }
      });
    }
  
    if (Object.keys(errors).length > 0) {
      setTestErrors(errors);
      setIsSubmit(false);
      return;
    }
  
    setTestErrors({});

    const statusMap = {
      approve: "1",
      reject: "2",
      correction: "3",
    };

    const status = statusMap[statuss.toLowerCase()];
    const payload = productSpecifications.map((spec) => ({
      sid: spec.id,
      test_result:
        testResults.find((result) => result.id === spec.id)?.testResult || "",
    }));
    const formData = new FormData();
    formData.append("production_id", props.rowData?.id);
    formData.append("test_result_remark", remark);
    formData.append("specification", JSON.stringify(payload));
    formData.append("status", status);
    formData.append("reject_reason", modalReason);
    formData.append("plant_id", props?.rowData?.plant_id);
    formData.append("product_id", props?.rowData?.product_id);
    formData.append("batch_id", props?.rowData?.batch_no_id);
    formData.append("bom_screen", JSON.stringify(Object.values(updatedFinishGood)));

    utils
      .callAPI("post", `/production/process/save-result-qc`, formData)
      .then((res) => {
        setModalReason("");
        setShowModal(false);
        setIsSubmit(false);
        props.onChange({ mode: "list" });
      })
      .catch((err) => {
        setIsSubmit(false);
      });
  };

  const handleActionClick = (action) => {
    setstatus(action);
    if (action === "approve") {
      setIsSubmit(true);
    } else if (action === "correction") {
      setIsSubmit(true);
    } else {
      setModalAction(action);
      setShowModal(true);
    }
  };

  const handleModalSubmit = () => {
    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit) {
      handleFinalSave();
    }
  }, [isSubmit]);

  return (
    <div className="section-body">
      {/* <RB.Card className="card shadow">
        <RB.Card.Header className="border-0"> */}
      <h5>{props.rowData?.product_name} Specification</h5>
      {/* <div className="card-header-action">
            <Link
              className="btn btn-underline me-2"
              onClick={props.onBackClick}
            >
              Back
            </Link>
          </div> */}
      {/* </RB.Card.Header> */}
      {/* <RB.Card.Body> */}
      <RB.Row className="mt-4">
        <RB.Col md={2}>
          <div>
            <span className="text-uppercase fw-bold small text-body-secondary">
              Product Name
            </span>
            <p className="fw-medium text-sm fw-semibold">
              {props.rowData?.product_name}
            </p>
          </div>
          <div>
            <span className="text-uppercase fw-bold small text-body-secondary">
              Batch No
            </span>
            <p className="fw-medium text-sm fw-semibold">
              {props.rowData?.batch_no}
            </p>
          </div>
          <div>
            <span className="text-uppercase fw-bold small text-body-secondary">
              MFG Month
            </span>
            <p className="fw-medium text-sm fw-semibold">
              {moment().format("MMM-YYYY")}
            </p>
          </div>
        </RB.Col>
        <RB.Col md={10}>
          <div className="table-responsive">
            <RB.Table striped bordered hover>
              <thead>
                <tr>
                  <th>TEST/PROPERTIES</th>
                  <th>SPECIFICATION</th>
                  <th>TEST RESULT</th>
                </tr>
              </thead>
              <tbody>
                {productSpecifications.map((spec) => (
                  <tr key={spec.id}>
                    <td>
                      <RB.Form.Control
                        type="text"
                        value={spec.properties}
                        readOnly
                      />
                    </td>
                    <td>
                      <RB.Form.Control
                        type="text"
                        value={spec.specification}
                        readOnly
                      />
                    </td>
                    <td className="mt-2">
                      <RB.Form.Control
                        type="text"
                        value={
                          testResults.find((result) => result.id === spec.id)
                            ?.testResult || ""
                        }
                        onChange={(e) =>
                          handleTestResultChange(spec.id, e.target.value)
                        }
                        required
                      />
                      {testErrors[spec.id] && (
                        <span className=" text-sm text-danger ms-3">
                          {testErrors[spec.id]}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
                {productSpecifications.length === 0 && (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No specifications found.
                    </td>
                  </tr>
                )}
              </tbody>
            </RB.Table>
          </div>
          <div className="mt-3">
            <RB.FloatingLabel
              controlId="formRemark"
              label="Remark"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="textarea"
                placeholder="Enter remarks"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </RB.FloatingLabel>
          </div>

          <div className="text-end mt-3">
            {utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.approve"
            ) && (
              <RB.Button
                variant="success"
                onClick={() => handleActionClick("approve")}
                disabled={productSpecifications.length == 0}
              >
                Approve
              </RB.Button>
            )}
            {utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.correction"
            ) && (
              <RB.Button
                className="ms-2"
                variant="warning"
                onClick={() => handleActionClick("correction")}
                disabled={productSpecifications.length == 0}
              >
                Correction
              </RB.Button>
            )}
            {utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.reject"
            ) && (
              <RB.Button
                className="ms-2"
                variant="danger"
                onClick={() => handleActionClick("reject")}
                disabled={productSpecifications.length == 0}
              >
                Reject
              </RB.Button>
            )}
          </div>
        </RB.Col>
      </RB.Row>
      {/* </RB.Card.Body> */}
      {/* </RB.Card> */}

      <RB.Modal show={showModal} onHide={() => setShowModal(false)}>
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>
            Provide Reason for{" "}
            {modalAction === "correction" ? "Correction" : "Rejection"}
          </RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          <RB.Form.Group>
            <RB.Form.Label>Reason</RB.Form.Label>
            <RB.Form.Control
              as="textarea"
              rows={3}
              value={modalReason}
              onChange={(e) => setModalReason(e.target.value)}
            />
          </RB.Form.Group>
        </RB.Modal.Body>
        <RB.Modal.Footer>
          <RB.Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </RB.Button>
          <RB.Button
            variant={`${modalAction == "correction" ? "primary" : "danger"}`}
            onClick={handleModalSubmit}
          >
            {modalAction == "correction" ? "Submit" : "Reject"}
          </RB.Button>
        </RB.Modal.Footer>
      </RB.Modal>
    </div>
  );
}

export default QCSpecification;
